<template>
<div class="text-left">
  <h1>Custom Javascript</h1>
  <!-- bidirectional data binding（双向数据绑定） -->
  <codemirror v-model="formJSCode" 
  :options="cmOptions"


   @input="onCmCodeChange"
  
  ></codemirror>

  
</div>

</template>

<script>
import sideBar from '../components/sidebar/sidebar.vue'
import { mapGetters,mapActions} from "vuex";
// language js
import 'codemirror/mode/javascript/javascript.js'
// theme css
import 'codemirror/theme/base16-dark.css'
// more codemirror resources
// import 'codemirror/some-resource...'
export default {
  name:"FormJsContainer",
  data () {
    return {
      formJSCode: '// Type your javascrip code here',
      cmOptions: {
        // codemirror options
        tabSize: 4,
        mode: 'text/javascript',
        theme: 'Paraiso-Light',
        lineNumbers: true,
        line: true
       
      }
    }
  },
  methods: {
    ...mapActions(["updateFormJSCode"]),
    onCmReady(cm) {
      // console.log('the editor is readied!', cm)
      alert('ready');
    },
    onCmFocus(cm) {
      alert('focus');
      // console.log('the editor is focus!', cm)
    },
    onCmCodeChange(newCode) {
      
      // console.log('this is new code', newCode)
      this.formJSCode = newCode
      this.updateFormJSCode(this.formJSCode);
    }
  },
  computed: {
    ...mapGetters(["form1"]),
    codemirror() {
      return this.$refs.myCm.codemirror
    }
  },
  mounted() {
   // // console.log('this is current codemirror object', this.codemirror)
    // you can use this.codemirror to do something...
  }
}
</script>